// Ops admin area: documents, complaints, suppliers, service catalog
// (supplier components) and templates.
export const opsAdmin = {
  common: {
    kind: "Kind",
    supplier: "Supplier",
    payment: "Payment",
    bookingMode: "Booking mode",
    global: "Global",
    globalAnyDestination: "Global (any destination)",
    noSupplier: "No supplier",
    order: "Order",
    editingName: "Editing: {{name}}",
  },
  documents: {
    title: "Documents",
    subtitle: "Generated contracts, itineraries & packages — with e-signature status",
    allDocuments: "All documents",
    contracts: "Contracts",
    searchPlaceholder: "Search by title…",
    audience: "Audience",
    empty: "No documents",
    colDocument: "Document",
    colSigned: "Signed",
    openPdf: "Open PDF",
  },
  complaints: {
    title: "Complaints",
    subtitle: "Customer complaints & compensation — tracked to resolution",
    empty: "No complaints",
    colComplaint: "Complaint",
    colCompensation: "Compensation",
  },
  suppliers: {
    title: "Suppliers",
    subtitle: "Hotels, airlines, insurers and vendors we buy services from",
    new: "New supplier",
    pricedCatalog: "Priced catalog",
    searchPlaceholder: "Search by name, contact, email…",
    empty: "No suppliers found",
    colSupplier: "Supplier",
    colContact: "Contact",
    paymentTermsDays_one: "{{count}}d",
    paymentTermsDays_few: "{{count}}d",
    paymentTermsDays_other: "{{count}}d",
    notFound: "Supplier not found",
    editTitle: "Edit supplier",
    newSubtitle: "Add a service supplier",
    namePlaceholder: "e.g. Sofitel Legend Metropole Hanoi",
    contactName: "Contact name",
    contactEmail: "Contact email",
    contactPhone: "Contact phone",
    emailTemplate: "Email template",
    emailTemplateDefault: "Default (automatic, kind-aware booking request)",
    emailTemplateHint:
      "Leave on Default unless this supplier insists on a fixed format — then point it at a template (clone “Supplier booking request” in Templates and edit it).",
    notesPlaceholder: "Booking contact, contract terms, anything the team should know…",
    paymentProfile: "Payment profile",
    paymentProfileHint: "Drives which payment obligations the ops engine watches.",
    bookingModeHint:
      "“On demand” = our own / always-available service (our boat): no booking-request email, no confirm deadline, ready by default. New catalogue items inherit this.",
    paymentTerms: "Payment terms (days)",
    commission: "Commission (%)",
  },
  components: {
    title: "Service catalog",
    subtitle: "Priced components — the cost master a garant picks from when composing a trip",
    new: "New component",
    searchPlaceholder: "Search by name…",
    costScope: "Cost scope",
    empty: "No components found",
    colComponent: "Component",
    colCost: "Cost",
    colSell: "Sell",
    colMargin: "Margin",
    colScope: "Scope",
    notFound: "Component not found",
    editTitle: "Edit component",
    newSubtitle: "Add a priced service to the catalog",
    namePlaceholder: "e.g. Halong Bay overnight cruise — deluxe cabin",
    notesPlaceholder: "What's included, booking conditions…",
    cost: "Cost",
    sellPrice: "Sell price",
    marginLabel: "Margin:",
    costScopeHint: "Fixed per departure (a chartered bus) or scales per person (insurance).",
    bookingModeHint:
      "“On demand” = our own / always-available (our boat): no supplier request, no confirm deadline, ready by default. Prefilled from the supplier; override here if needed.",
  },
  templates: {
    title: "Templates",
    subtitle: "Manage email and PDF templates",
    new: "New template",
    searchPlaceholder: "Search templates…",
    allTypes: "All types",
    allCategories: "All categories",
    empty: "No templates",
    createFirst: "Create first template",
    systemChip: "System",
    updatedAt: "Updated: {{date}}",
    toastDuplicated: "Template duplicated",
    toastDuplicateFailed: "Failed to duplicate template",
    toastDeleted: "Template deleted",
    toastDeleteFailed: "Failed to delete template",
    systemCannotDelete: "System templates cannot be deleted",
    deleteTitle: "Delete template",
    deleteMessage: 'Are you sure you want to delete template "{{name}}"? This cannot be undone.',
    editTitle: "Edit template",
    versionCount: "Version: {{version}}",
    versionHistory: "Version history",
    aiGeneration: "AI generation",
    contentPlaceholder: "Start writing template content…",
    toastCreated: "Template created",
    toastSaved: "Template saved",
    toastSaveFailed: "Failed to save template",
    errNameRequired: "Enter template name",
    errContentRequired: "Enter template content",
    namePlaceholder: "Template name",
    descriptionPlaceholder: "Optional description",
    category: "Category",
    subject: "Subject",
    subjectPlaceholder: "Email subject",
    categories: {
      newsletter: "Newsletter",
      booking: "Booking confirmation",
      payment: "Payments",
      contract: "Contracts",
      invoice: "Invoices",
      voucher: "Vouchers",
      other: "Other",
    },
    types: {
      email: "Email",
      pdf: "PDF document",
    },
    variables: "Variables",
    variableGroups: {
      customer: "Customer",
      trip: "Trip",
      order: "Order",
      guide: "Guide",
      company: "Company",
      voucher: "Voucher",
    },
    preview: "Preview",
    previewEmpty: "Preview will appear here…",
    previewIframeTitle: "Template preview",
    versionRestored: "Version restored",
    restoreFailed: "Failed to restore version",
    noVersions: "No versions",
    versionN: "Version {{version}}",
    current: "Current",
    noNote: "No note",
    restore: "Restore",
    aiTitle: "AI Content Generation",
    aiDescribe: "Describe the template",
    aiPromptPlaceholder:
      "E.g.: Create an email for booking confirmation for a trip to Vietnam with deposit payment information.",
    aiTone: "Communication tone",
    toneFormal: "Formal",
    toneFriendly: "Friendly",
    toneExcited: "Excited",
    generate: "Generate",
    generatedSubject: "Generated subject",
    generatedContent: "Generated content",
    use: "Use",
    aiGenerateFailed: "Failed to generate content",
  },
};
